import z from "zod"
import { Errors } from "../../errors"

export const GorgiasIntegrationResponseDataSchema = z
  .object({
    maskedToken: z.string(),
    username: z.string(),
    baseApiUrl: z.string(),
  })
  .nullish()

export const UpsertGorgiasIntegrationResponseDataSchema = z.object({
  maskedToken: z.string(),
  username: z.string(),
  baseApiUrl: z.string(),
})

export const GorgiasPriorityEnum = {
  low: "low",
  normal: "normal",
  high: "high",
  critical: "critical",
} as const

export const CreateGorgiasTicketConfigSchema = z.object({
  subject: z.string().min(1, { message: Errors.GORGIAS_SUBJECT_REQUIRED }),
  body: z.string().min(1, { message: Errors.GORGIAS_BODY_REQUIRED }).default("{{ data.summary }}"),
  priority: z.nativeEnum(GorgiasPriorityEnum).optional().default(GorgiasPriorityEnum.normal),
  tags: z
    .string()
    .transform((el) => (el && el.trim().length > 0 ? el : null))
    .nullish(),
})

export const TestGorgiasIntegrationResponseDataSchema = z.object({
  data: CreateGorgiasTicketConfigSchema,
  eventPayload: z.record(z.string(), z.any()),
})
